module.exports = __webpack_public_path__ + "img/camera_white.ce8bb0b0.svg";